import styled from "styled-components";

export const Backdrop = styled.div`
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    transition: opacity 0.5s ease-out;
    opacity: 1;
    overflow: hidden;
    z-index: 1050;
    overflow-y: auto;
    pointer-events: all;

    &[hidden] {
        display: none;
    }
`;

export const Wrapper = styled.div<{ show: boolean }>`
    display: flex;
    position: fixed;
    top: ${({ show }) => (show ? 0 : "100vh")};
    left: 0;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: white;
    transition: all 0.5s;
    overflow: hidden;
    visibility: ${({ show }) => (show ? "visible" : "hidden")};
    z-index: 1060;
`;

export const CloseFullScreen = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: fit-content;
    padding: var(--spacing-2);

    z-index: 1080;
`;
